import React, { Component } from "react";
import { useEffect, useState } from 'react';
import axios from 'axios'; // Asegúrate de importar axios
// Import from bootstrap
import { Container, Row, Col } from "react-bootstrap";

// Import constant url
import { AGENT_ART_URL, AGENT_VIDEO_URL } from "../utils/Const";

// Import agents data
// import { agentsData } from "../AgentsData";

// Import Components
import SelectAgentsComp from "./SelectAgentsComp";
import AgentsDesc from "./AgentsDesc";
import AgentSkill from "./AgentSkill";
import { agentsData } from "../AgentsData";
let currentURL = window.location.href.split("/");
let idMapa = currentURL[4];



const AgentsComp = () => {
  
  const [agentsDataAPI, setAgentsDataAPI] = useState([]); // Cambia aquí el nombre de la variable
  const [combinedAgentsData, setCombinedAgentsData] = useState([]);
 
  
  // console.log("uuid por url:  " + idMapa);
  useEffect(() => {
    axios.get('https://valorant-api.com/v1/agents?language=es-MX&isPlayableCharacter=true')
      .then(response => {
        const apiAgentsData = response.data.data;
        setAgentsDataAPI(apiAgentsData);
  
        const combinedData = apiAgentsData.map((apiAgent) => {
          const localAgent = agentsData.find((agent) => agent.uuid === apiAgent.uuid);
  
          // Definir un mapeo de los nombres de las habilidades a su posición deseada
          const abilitySlotMap = {
            "Ability1": 1,
            "Ability2": 2,
            "Grenade": 3,
            "Ultimate": 4,
          };
  
          const abilitiesWithId = apiAgent.abilities
            .filter((ability) => abilitySlotMap.hasOwnProperty(ability.slot)) // Filtrar habilidades válidas
            .map((ability) => {
              // Obtener la posición de la habilidad en el mapa
              const position = abilitySlotMap[ability.slot];
  
              return {
                ...ability,
                id: position,
              };
            });
  
          return {
            ...apiAgent,
            abilities: abilitiesWithId, // Reemplazar el array de habilidades con identificadores
            ...localAgent,
          };
        });
  
        setCombinedAgentsData(combinedData);
      })
      .catch(error => {
        console.error('Error al obtener los datos de la API:', error);
      });
  }, []);
  // console.log(combinedAgentsData);
  const filteredAgents = combinedAgentsData.filter(agent => agent.uuid === idMapa);
  console.log("AgentsComp: ");
  console.log(filteredAgents);
  
    return (
      <div className="agents-header-container">       
            <video autoPlay muted loop id="myVideo">
              <source src={AGENT_VIDEO_URL + "agent-header-bg.mp4"} type="video/mp4" />
            </video>
            <div className="header-overlay"></div>
            <Container className="agents-header-section text-white">
            {filteredAgents.map(agent => (
              <div className="img-container w-100 d-flex justify-content-center" id="agentArt">
                <img src={agent.fullPortrait} alt="header-char" />
              </div>
              ))}
            </Container>
            <Container>
            {filteredAgents.map(agent => (
              <Row className="agent-header-text">
                <Col lg={8}>
                  <div className="agent-number responsive-image"  id="agentNumber">
                    <h1><strong>{agent.id}</strong></h1>
                  </div>
                </Col>
                <Col>
                  <AgentsDesc id="agentDesc" agentName={agent.displayName} agentBio={agent.description} agentRole={agent.role.displayName} agentRolIco={agent.role.displayIcon}/>
                </Col>
              </Row>
              ))}
            </Container>  
            {filteredAgents.map(agent => (       
            // <AgentSkill agentName={agent.displayName}  />
            <AgentSkill   filteredAgents={filteredAgents}/>
            ))}
            {/* <SelectAgentsComp agentIndex={agentIndex} /> */}
            <SelectAgentsComp />
            
            
      </div>
    );

}
export default AgentsComp
